import React from "react";
import { useTranslation } from 'react-i18next';
import SeoHead from "../seo/SeoHead";
import ServicePage, { RelatedServices, ServiceChecklist, ServiceCta, ServiceFaq, ServiceHero } from "./ServicePageLayout";
import PostRepairImage from "../../assets/post-repair.png";

const PostRepairVerification = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';
    const lang = i18n.language === 'en' ? 'en' : 'ar';
    const faq = t('postRepairPage.faq', { returnObjects: true });

    return (
        <ServicePage isRTL={isRTL}>
            <SeoHead
                path="services/post-repair-verification"
                title={t('postRepairPage.metaTitle')}
                description={t('postRepairPage.metaDescription')}
                keywords={t('postRepairPage.keywords')}
                jsonLd={{
                    '@context': 'https://schema.org',
                    '@type': 'FAQPage',
                    mainEntity: faq.map(({ q, a }) => ({
                        '@type': 'Question',
                        name: q,
                        acceptedAnswer: { '@type': 'Answer', text: a },
                    })),
                }}
            />

            <ServiceHero
                eyebrow={t('postRepairPage.eyebrow')}
                title={t('postRepairPage.title')}
                intro={t('postRepairPage.description', { companyName: isRTL ? 'البروفيسور لفحص السيارات' : 'Al Professor Technical Inspection', location: isRTL ? 'أبوظبي' : 'Abu Dhabi' })}
                image={PostRepairImage}
                imageAlt={t('postRepairPage.imageAlt')}
                ctaLabel={t('postRepairPage.ctaLabel')}
                ctaMessage={isRTL ? 'مرحباً، أرغب في حجز فحص ما بعد الإصلاح.' : 'Hi, I would like to book a post-repair verification.'}
            />

            <ServiceChecklist title={t('postRepairPage.verifyTitle')} points={t('postRepairPage.verifyPoints', { returnObjects: true })} />
            <ServiceFaq title={t('postRepairPage.faqTitle')} items={faq} />
            <RelatedServices title={t('postRepairPage.related.title')} items={t('postRepairPage.related.items', { returnObjects: true })} lang={lang} />

            <ServiceCta
                eyebrow={t('postRepairPage.eyebrow')}
                title={t('postRepairPage.title')}
                body={t('postRepairPage.metaDescription')}
                ctaLabel={t('postRepairPage.ctaLabel')}
                ctaMessage={isRTL ? 'مرحباً، أرغب في حجز فحص ما بعد الإصلاح.' : 'Hi, I would like to book a post-repair verification.'}
            />
        </ServicePage>
    );
};

export default PostRepairVerification;
